<template>
  <div class="content">
    <div class="main">
      <div class="title">{{name}}</div>
      <div class="datashow">
        <div class="showbox">
          <div class="rightbox">
            <div class="rightnum">
              <div class="num">{{rightnum}}</div>答对题数
            </div>
          </div>

          <div class="showtext">
            <div class="left">总题数</div>

            <div class="sptext all">{{total}}</div>道
          </div>
          <div class="showtext">
            <div class="left">答题时间</div>

            <div class="sptext lt">{{duration}}</div>
          </div>
          <div class="showtext">
            <div class="left">正确率</div>

            <div class="sptext lt">{{rate}}</div>
          </div>
        </div>
      </div>
      <div class="answer-card">
        <div class="head">答题卡</div>
        <div class="showcard">
          <div class="card-group" v-for="(item,index) in parentPage" :key="index">
            <div
              class="cards default"
              v-for="(n,ind) in item"
              :class="{right:list[n-1].is_right == 1,
              error:list[n-1].is_right == 0,
              mg:(ind + 1) / 5 == 0}"
              :key="ind"
              @click="toQuestion(ind)"
            >{{n}}</div>
          </div>
          <!-- :class="{right:is_right[index] == 1,error:is_right[index] == 0,mg:ind==4||ind==9||ind==14 }" -->
        </div>
      </div>
      <div class="btn">
        <div class="left">
          <a-button type="primary" size="large" @click="toExplan">试题解析</a-button>
        </div>
        <div class="right">
          <a-button type="primary" size="large" v-if="sign != 3" @click="rest">再做一遍</a-button>
          <a-button type="primary" size="large" v-if="sign == 3" @click="rests">完成考试</a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      name: "",
      is_right: '',
      list: []
    };
  },
  computed: mapState(["answerList", "explanList", "record"]),
  methods: {
    ...mapMutations(["setAnswerList", "setExplanList", "setRecord"]),
    menuList(len) {
      this.len = len;
      let arr1 = [];
      let arr2 = [];
      for (let index = 0; index < len; index++) {
        let numb = index + 1;
        arr1.push(numb);
        if (numb % 20 == 0 || numb == len) {
          arr2.push(arr1);
          arr1 = [];
        }
      }
      this.pageList = arr2[0];
      this.parentPage = arr2;
      this.list = this.explanList
      // this.explanList.forEach(function(item){
      //   let newli = item
      //   if (item.my_answer) {
      //     let myAnswer = [...new Set(newli.my_answer.split(","))]
      //     let newAnswer = [...new Set(newli.answer.split(","))] 
      //     if (myAnswer && newAnswer) {
      //       isRight = myAnswer.sort().toString() == newAnswer.sort().toString() ? 1 : 0;
      //     } 
      //   } else {
      //     isRight = 2
      //   }
      //   isRi.push(isRight)
      // })
      // this.is_right = isRi
    },
    toExplan() {
      this.$router.push({
        path: "/page/question/quiz",
        query: {
          id: this.id,
          sign: this.sign,
          paperclass: 1,
          qtype: 1,
          name: this.name,
          nosure: true,
          nosu: false
        }
      });
    },
    rest() {
      if (this.sign != 2 && this.sign != 3) {
        this.$router.push({
          path: "/page/question/quiz",
          query: {
            id: this.id,
            sign: this.sign,
            paperclass: 1,
            qtype: 1,
            name: this.name,
            course_id :this.course_id,
            chapterId : this.chapter_id,
            partId : this.part_id,
          }
        });
      } else {
        this.$router.push({
          path: "/page/question/quiz",
          query: {
            id: this.id,
            sign: this.sign,
            paperclass: 1,
            qtype: 2,
            name: this.name
          }
        });
      }
    },
    rests() {
      this.$router.push({
          path: "/page/question",
        });
    }
  },
  created() {
    this.name = this.$route.query.name;
    this.rightnum = this.$route.query.rightnum;
    this.total = this.$route.query.total;
    this.duration = this.$route.query.duration;
    this.rate = this.$route.query.rate;
    this.id = this.$route.query.paper_id;
    this.sign = this.$route.query.sign;
    this.course_id=this.$route.query.course_id,
            this.chapter_id = this.$route.query.chapter_id,
            this.part_id = this.$route.query.part_id,
    this.menuList(this.answerList.length);
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/report.less');
</style>